import { CheckIcon } from '@heroicons/react/24/outline';
import { cn } from '@/lib/utils';

export type TryoutFunnelStep = 'upload' | 'empty' | 'result';

interface TryoutProgressBarProps {
  step: TryoutFunnelStep;
}

const STEPS: { id: string; label: string }[] = [
  { id: 'upload', label: 'Hochladen'   },
  { id: 'empty',  label: 'Leerräumen'  },
  { id: 'result', label: 'Ergebnis'    },
];

const stepIndex = (step: TryoutFunnelStep): number => {
  if (step === 'upload') return 0;
  if (step === 'empty')  return 1;
  return 2; // result
};

export const TryoutProgressBar: React.FC<TryoutProgressBarProps> = ({ step }) => {
  const current = stepIndex(step);

  return (
    <div
      className="flex items-center justify-center gap-0 mb-8"
      style={{ fontFamily: "'Outfit Variable', 'Outfit', sans-serif" }}
    >
      {STEPS.map(({ id, label }, index) => {
        const done   = current > index;
        const active = current === index;
        return (
          <div key={id} className="flex items-center">
            <div className="flex flex-col items-center">
              <div className={cn(
                'w-8 h-8 rounded-full flex items-center justify-center text-[13px] font-semibold transition-all duration-300 border',
                done
                  ? 'bg-[#FE6F17] text-white border-[#FE6F17]'
                  : active
                  ? 'bg-[#FE6F17] text-white border-[#FE6F17] ring-[3px] ring-[#FE6F17]/20'
                  : 'bg-white text-[#9CA3AF] border-[#EBEBE6]',
              )}>
                {done ? <CheckIcon className="w-4 h-4" strokeWidth={2.5} /> : index + 1}
              </div>
              <span className={cn(
                'text-[11px] mt-2 font-semibold whitespace-nowrap tracking-wide',
                active ? 'text-[#001116]' : done ? 'text-[#5F6B70]' : 'text-[#9CA3AF]',
              )}>
                {label}
              </span>
            </div>

            {index < STEPS.length - 1 && (
              <div className={cn(
                'w-16 sm:w-28 h-px mx-3 mb-5 transition-colors duration-300',
                current > index ? 'bg-[#FE6F17]' : 'bg-[#EBEBE6]',
              )} />
            )}
          </div>
        );
      })}
    </div>
  );
};
